<template>
    <v-container class="pa-4 text-center">
        <template>
            <p class="display-1 font-weight-light">Daftar Layanan</p>
            <p class="pl-8 body-2 text-left font-weight-bold mt-5">Pilih kategori layanan: </p>
            <v-layout row wrap>
                <template v-for="(item, i) in item_categories">
                    <v-flex xs3 class="my-4" :key="i">
                        <template>
                            <v-card
                                class="mx-auto"
                                color="green lighten-5"
                                max-width="200"
                                height="100%"
                                style="cursor: pointer"
                                @click="onSelectProductCategory(item)"
                            >
                                <v-img
                                    :aspect-ratio="16/9"
                                    src="https://cdn.vuetifyjs.com/images/cards/kitchen.png"
                                    class="white--text align-end"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                    height="50px"
                                >
                                    <v-card-text class="text-left" v-text="item.name+' ('+item.total_products+')'"></v-card-text>
                                </v-img>
                                <!-- <v-card-text
                                    class="pt-6 text-left"
                                    style="position: relative; height:auto"
                                >
                                    <span class="font-weight-light subtitle-2 black--text">{{item.name}}</span><br />
                                    <span class="font-weight-medium caption black--text">Jumlah Layanan: {{item.total_products}}</span><br />
                                </v-card-text> -->
                            </v-card>
                        </template>
                    </v-flex>
                </template>
            </v-layout>
        </template>
        <template v-if="isShowLayanan">
          <p class="pl-8 body-2 text-left font-weight-light mt-5">Menampilkan {{selectedCategory.total_products}} layanan dari kategori {{selectedCategory.name}}</p>
          <v-layout row wrap>
              <template v-for="(item, i) in listLayanan">
                  <v-flex xs3 class="my-4" :key="i">
                      <template>
                          <v-hover v-slot:default="{ hover }">
                              <v-card
                                  class="mx-auto"
                                  color="green lighten-5"
                                  max-width="200"
                                  height="100%"
                              >
                                  <v-img
                                      :aspect-ratio="16/9"
                                      src="https://cdn.vuetifyjs.com/images/cards/kitchen.png"
                                  >
                                  <v-expand-transition>
                                      <div
                                          v-if="hover"
                                          class="green darken-2 d-flex transition-fast-in-fast-out v-card--reveal white--text"
                                          style="height: 100%;"
                                      >
                                          <span>Available</span>
                                      </div>
                                  </v-expand-transition>
                                  </v-img>
                                  <v-card-text
                                      class="pt-6 text-left"
                                      style="position: relative; height:auto"
                                  >
                                      <v-btn
                                          absolute
                                          color="green darken-1"
                                          class="white--text"
                                          x-small
                                          fab
                                          right
                                          top
                                          @click.stop="dialog = true"
                                      >
                                          <v-icon>add</v-icon>
                                      </v-btn>
                                      <span class="font-weight-light subtitle-2 black--text">{{item.name}}</span><br />
                                      <span class="font-weight-medium caption black--text">Harga: Rp. {{item.harga_jual}}</span>
                                  </v-card-text>
                              </v-card>
                          </v-hover>
                      </template>
                  </v-flex>
              </template>
          </v-layout>
        </template>
        <v-dialog v-model="dialog" max-width="500">
          <v-card>
            <v-container>
              <v-form @submit.prevent="addEvent">
                <v-row align="center">
                  <v-col class="d-flex" cols="12" sm="6">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="inputStart"
                          label="Tanggal Mulai"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="inputStart" @change="[onCekJadwal(), inputEnd = inputStart]" @input="menu = false"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="6">
                    <v-select :items="jamItemsStart" v-model="startJam" @change="onCekJadwal" label="Jam"></v-select>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="6">
                    <v-menu
                      v-model="menuFinish"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="inputEnd"
                          label="Tanggal Selesai"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="inputEnd" @change="onCekJadwal" @input="menuFinish = false"></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col class="d-flex" cols="12" sm="6">
                    <v-select :items="jamItemsFinish" v-model="finishJam" @change="onCekJadwal" label="Jam"></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12" v-if="jasaItems.length > 0">
                    <v-select prepend-icon="add_shopping_cart" :items="jasaItems" v-model="selectedJasa" label="Pilih Layanan"></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="12" v-else>
                    <p class="font-italic red--text caption">*Tidak ditemukan, silahkan cari jadwal lain.</p>
                  </v-col>
                </v-row>
                <v-btn type="submit" color="primary" v-if="jasaItems.length > 0 && selectedJasa" class="mr-4">
                  Book
                </v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { forEach, findIndex, find, remove } from "lodash";
export default {
    name: "Dashboard",
    data: () => ({
        item_layanan: [],
        item_categories: [],
        isShowLayanan: false,
        selectedCategory: null,
        selectedCategoryLayanan: 'ALL',
        menu: false,
        menuFinish: false,
        jamItemsStart: [],
        jamItemsFinish: [],
        startJam: null,
        finishJam: null,
        inputStart: null,
        inputEnd: null,
        name: null,
        details: null,
        start: null,
        end: null,
        color: '#1976D2', // default event color
        currentlyEditing: null,
        selectedEvent: {},
        selectedElement: null,
        selectedJasa: null,
        selectedOpen: false,
        dialog: false,
        available: [],
        jasaItems: [],
        dataJadwal: null
    }),
    computed: {
        ...mapState({
            listLayanan: state => state.jadwal.allProductJasa,
            productJasa: state => state.jadwal.productJasa,
            allProductJasa: state => state.jadwal.allProductJasa,
            listPesanan: state => state.products.listPesanan
        }),
    },
    async created(){
        this.showLoading({ color: 'white' })
        await this.getProductJasa('ALL')

        forEach(this.listLayanan, list => {
          list.harga_jual = Number(list.harga_jual)
        })

        for (let i = 0; i < 24; i++) {
          this.jamItemsStart.push({
            text: i.toString().length == 1 ? '0' + i + ':00' : i + ':00',
            value: i.toString().length == 1 ? '0' + i + ':00:01' : i + ':00:01'
          })

          this.jamItemsFinish.push({
            text: i.toString().length == 1 ? '0' + i + ':00' : i + ':00',
            value: i.toString().length == 1 ? '0' + i + ':00:00' : i + ':00:00'
          })
        }

        const responseCategory = await this.getProductCategory(['MANAGED_TIME'])

        if(responseCategory.data.status){
            forEach(responseCategory.data.attributes, data => {
                this.item_categories.push(data)
            })
        }else{
            this.showSnackbar({ text: responseCategory.data.message, color: 'red', timeout: 1500 })
        }
        this.closeLoading()
    },
    methods: {
        ...mapMutations({
            showSnackbar: "showSnackbar",
            showLoading: "showLoading",
            closeLoading: "closeLoading",
            setListPesanan : "products/SET_LIST_PESANAN",
            setProductJasa : "jadwal/SET_PRODUCT_JASA",
        }),
        ...mapActions({
            getProductJasa: "jadwal/getProductJasa",
            cekJadwal: "jadwal/cekJadwal",
            calculateTotal: "products/calculateTotal",
            getProductCategory: "products/getProductCategory"
        }),
        async onCekJadwal(){
            let d1 = new Date(this.inputStart + " " + this.startJam.replace(":01", ":00"));
            let d2 = new Date(this.inputEnd + " " + this.finishJam);
            let greaterThanDate = d1.getTime() > d2.getTime();
            
            if(!greaterThanDate){
              await this.getProductJasa(this.selectedCategoryLayanan)
              forEach(this.listLayanan, list => {
                list.harga_jual = Number(list.harga_jual)
              })

              this.jasaItems = [];
              let available = this.productJasa
              if (this.inputStart && this.inputEnd && this.startJam && this.finishJam && (this.inputStart + " " + this.startJam.replace(":01", ":00") != this.inputEnd + " " + this.finishJam)) {
                const payload = {
                    from: this.inputStart + " " + this.startJam,
                    to: this.inputEnd + " " + this.finishJam
                }
                const response = await this.cekJadwal(payload)

                forEach(response.data.attributes, data => {
                  remove(available, function(currentObject) {
                      return currentObject.value === data.product_id;
                  });
                })

                forEach(available, ava => {
                  this.jasaItems.push(ava)
                })
              } 
            }else{
              this.jasaItems = [];
            }
        },
        async addEvent () {
            const selectedProduct = find(this.allProductJasa, jasa => jasa.id == this.selectedJasa)

            const start = new Date(this.inputStart+' '+this.startJam)
            const end = new Date(this.inputEnd+' '+this.finishJam)

            let currentPesanan = this.listPesanan
            const itemPesanan = {
                product_id: selectedProduct.id,
                item_name: selectedProduct.name,
                harga_jual: Number(selectedProduct.harga_jual),
                qty: (end - start + 1000)/3600000,
                discount: 0,
                ppn: 0,
                stock: (end - start + 1000)/3600000,
                mulai: this.inputStart+' '+this.startJam,
                selesai: this.inputEnd+' '+this.finishJam
            }

            currentPesanan.push(itemPesanan)

            this.setListPesanan(currentPesanan)
            this.calculateTotal()

            this.dialog = false
            this.inputStart = null
            this.inputEnd = null
            this.startJam = null
            this.finishJam = null
            this.selectedJasa = null
        },
        async onSelectProductCategory(item){
            this.showLoading({ color: 'white' })
            this.selectedCategory = item
            this.selectedCategoryLayanan = item.id
            await this.getProductJasa(this.selectedCategoryLayanan)

            forEach(this.listLayanan, list => {
              list.harga_jual = Number(list.harga_jual)
            })
            this.isShowLayanan = true
            this.closeLoading()
        }
    },
};
</script>
<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
</style>
